import { render, staticRenderFns } from "./ManageAccessFunctionalities.vue?vue&type=template&id=7c571a5b&lang=pug"
import script from "./ManageAccessFunctionalities.vue?vue&type=script&lang=js"
export * from "./ManageAccessFunctionalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports